import React from 'react'
import { Yup } from 'cng-web-lib'

const ValidationSchema = () => {

  return Yup.object({
    input: Yup.string().required('Required/Mandatory').max(255, 'Input cannot be more than 255 characters.'),
    output: Yup.string().required('Required/Mandatory').max(255, 'Output cannot be more than 255 characters.')
  })
}

export default ValidationSchema

